import { Component, OnDestroy, OnInit } from '@angular/core';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { Subject, takeUntil } from 'rxjs';
import { PreferencesService } from 'src/app/shared/services/preferences.service';

export interface GlobalNotificationConfirmInput {
  message: string;
}

@Component({
  selector: 'app-global-notification-confirm-popup',
  templateUrl: './global-notification-confirm-popup.component.html',
  styleUrls: ['./global-notification-confirm-popup.component.scss']
})
export class GlobalNotificationConfirmPopupComponent implements OnInit, OnDestroy, IDialogContentComponent<boolean, GlobalNotificationConfirmInput> {
  input?: GlobalNotificationConfirmInput;
  isDarkMode = false;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly preferencesService: PreferencesService) {}

  ngOnInit(): void {
    this.preferencesService.getPreferences()
      .pipe(takeUntil(this.destroy$))
      .subscribe(preferences => {
        this.isDarkMode = preferences.preferenciesObject?.isDarkMode || false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getResult(): boolean {
    return true; // Confirmation
  }

  isDisabled(): boolean {
    return false; // Toujours activé
  }
}
